<template>
  <v-app>
    <div
      v-if="isloginrestrictval && !invalidSite"
      align="center"
      justify="center"
      class="full-height loading-container mx-5"
    >
      <iframe
          :src="security_url"
          width="100%"
          height="100%"
          class="iframe-styles"
          style="border: none; overflow-y: scroll; overflow: scroll; -webkit-overflow-scrolling: touch; height: 500px; width: 100%; height: 600px;"
          allowfullscreen="true"
          webkitallowfullscreen="true"
          frameborder="0"
          scrolling="yes"
        ></iframe>
    </div>

    <!-- 404 Card -->
    <v-container v-if="invalidSite" class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="5">
          <v-card class="elevation-8 text-center pa-6">
            <v-icon size="80" color="grey lighten-1" class="mb-4">mdi-alert-circle-outline</v-icon>
            <v-card-title class="justify-center text-h3 font-weight-bold grey--text text--darken-2">
              404
            </v-card-title>
            <v-card-subtitle class="text-h6 mt-2">
              Page Not Found
            </v-card-subtitle>
            <v-card-text class="text-body-1 grey--text">
              The page you are looking for does not exist or the URL is invalid.
            </v-card-text>
            <v-card-actions class="justify-center pb-4">
              <v-btn color="primary" class="px-4" large href="https://www.basusa.com">
                
                Visit BASusa.com
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <div v-if="!invalidSite" style="width: 100%">
      <!-- Navigation Drawer -->

      <v-navigation-drawer v-model="drawer" right app temporary>
        <v-list>
          <v-list-group
            v-for="menu in menusWithSubmenus"
            :key="menu.name"
            :value="false"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-title>{{ menu.name }}</v-list-item-title>
            </template>
            <v-list-item
              v-for="submenu in menu.submenus"
              :key="submenu.name"
              @click="openModal(submenu)"
            >
              <v-list-item-title style="white-space: wrap">{{
                submenu.name
              }}</v-list-item-title>
            </v-list-item>
          </v-list-group>

          <v-list-item
            v-for="menu in menusWithoutSubmenus"
            :key="menu.id"
            @click="openModal(menu)"
          >
            <v-list-item-title>
              {{ menu.name }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>

      <!-- Modal Window -->
    <div>
        <v-dialog v-model="plansDialog" width="600px" height="850px">
          <v-card>
            <v-card-title>&nbsp;</v-card-title>
            <v-card-text>
              <v-alert style="background-color: #efefef;" variant="tonal" class="mb-4">
                Click the button below to see this PDF within a new tab.
              </v-alert>

                  <v-btn
                    v-if="selectedSubmenu.file_url"
                    :href="selectedSubmenu.file_url"
                    target="_blank"
                    rel="noopener"
                    color="primary"
                    block
                  >
                    Open PDF
                  </v-btn>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="plansDialog = false">Close</v-btn>
                  </v-card-actions>
            </v-card-text>
          </v-card>
        </v-dialog>
        </div>
      <div>
        <v-dialog v-model="dialog" width="600px" height="850px">
          <v-card>
            <v-card-title>{{ selectedSubmenu.name }}</v-card-title>
            
            <v-card-text>
              <iframe
                v-if="selectedSubmenu.file_url"
                :src="selectedSubmenu.file_url"
                width="100%"
                height="500px"
                frameborder="0"
              ></iframe>
              <p v-else>Additional information coming soon.</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="dialog = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

      <div class="width-wrapper flex-row-wrapper" style="padding: 15px">
        <div class="login-topbar">
          <!-- ATTENTION: LOGO LOCATED HERE -->

          <div class="flex-row-wrapper">
            <div class="logo-wrapper"></div>
            <div style="padding-left: 10px; color: #8d8d7d; font-weight: 600">
              {{ this.logoText }}
            </div>
          </div>
        </div>

        <!-- <v-spacer></v-spacer> -->

        <!-- Desktop Menu with Submenus -->
        <div v-show="$vuetify.breakpoint.mdAndUp" class="desktop-menu">
          <!-- Menus with Submenus -->
          <div class="menu-with-submenus">
            <v-menu v-for="menu in menusWithSubmenus" :key="menu.name" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn text v-bind="attrs" v-on="on">
                  {{ menu.name }}
                  <v-icon right>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list v-if="menu.submenus">
                <v-list-item
                  v-for="submenu in menu.submenus"
                  :key="submenu.name"
                  @click="openModal(submenu)"
                >
                  <v-list-item-title>{{ submenu.name }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

          <!-- Menus without Submenus -->
          <div class="menu-without-submenus">
            <div
              v-for="menu in menusWithoutSubmenus"
              :key="menu.id"
              class="menu-button"
            >
              <v-btn text @click="openModal(menu)">
                {{ menu.name }}
              </v-btn>
            </div>
          </div>
        </div>

        <div style="max-width: 200px; text-align: right">
          <div class="flex-row-wrapper" style="max-width: 300px">
            <div style="flex: 1">
              <v-btn
                icon
                @click="drawer = !drawer"
                v-show="$vuetify.breakpoint.smAndDown"
              >
                <v-icon>mdi-menu</v-icon>
              </v-btn>
            </div>

            <div style="flex: 1">
              <a
                href="https://www.myenroll.com/web_projects/MainHomePage/Login.aspx"
                style="text-decoration: none"
                ><div class="login-topbar-btn">Login</div></a
              >
            </div>
          </div>
        </div>
      </div>

      <!-- HEADER IMAGE SECTION -->

      <div class="page-header">&nbsp;</div>

      <!-- HEADER TEXT SECTION -->

      <div style="margin-bottom: 20px; width: 100%">
        <div class="header-text-BG" style="text-align: center">
          <div class="width-wrapper flex-row-wrapper">
            <div class="header-text" style="margin: 0 auto">
              <h1 v-html="association.header.title"></h1>
              <p v-html="association.header.subtitle"></p>

              <div
                style="
                  text-align: center;
                  width: 100%;
                  margin: 0 auto;
                  text-align: center;
                "
              >
                <div
                  class="flex-row-wrapper"
                  style="
                    max-width: 400px;
                    margin: 0 auto;
                    text-align: center;
                    padding-bottom: 20px;
                  "
                >
                  <a
                    v-if="quoteBtn === 1"
                    @click="openshow_enrollquotedialog('quote')"
                    style="flex: 1; text-decoration: none; padding: 5px"
                  >
                    <div class="branded-btn">Quote</div>
                  </a>
                  <a
                    v-if="enrollBtn === 1"
                    @click="openshow_enrollquotedialog('enroll')"
                    style="flex: 1; text-decoration: none; padding: 5px"
                  >
                    <div class="branded-btn">Enroll</div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="background-color: #fcfefe">
        <div class="card-wrapper">
          <div class="card-flex-section">
            <div
              class="card-size"
              v-for="(plan, index) in association.planOptions"
              :key="index"
            >
              <div class="card-styles">
                <div class="card-topcolor bg-topcolor">&nbsp;</div>
                <div class="card-signifier-wrapper">
                  <div
                    class="card-signifier"
                    :class="plan.signifierClass"
                    style="color: #fff"
                    v-if="plan.signifier"
                  >
                    {{ plan.signifier }}
                  </div>
                </div>
                <div class="card-padding-withSignifiers">
                  <div class="flex-row">
                    <div class="card-img-wrapper">
                      <div class="img-border branded-bordercolor">
                        <img :src="plan.img" class="card-img1" />
                      </div>
                    </div>
                    <div style="flex: 3">
                      <p class="card-header">
                        <b>{{ plan.title }}</b>
                      </p>
                      <p class="card-description">{{ plan.description }}</p>
                    </div>
                  </div>
                  <div class="flex-row">
                    <div style="flex: 1">&nbsp;</div>

                    <div class="flex-row">
                     
                      <div @click="GetPlanCost(plan.cat_code)" class="card-btn">
                        Cost
                      </div>
                     
                      <div
                        v-if="quoteBtn === 1"
                        @click="openshow_enrollquotedialog('quote')"
                        class="card-btn"
                      >
                        Quote
                      </div>
                     
                      <div
                        v-if="enrollBtn === 1"
                        @click="openshow_enrollquotedialog('enroll')"
                        class="branded-enroll-card-btn"
                      >
                        Enroll
                      </div>

                    
                      <template v-if="costDialog">
                        <v-dialog v-model="costDialog" max-width="800px">
                          <v-card>
                            <v-card-title class="headline">Cost</v-card-title>
                            <v-card-text>
                              <v-data-table
                                :headers="headers"
                                :items="groupedPlans"
                                class="elevation-1"
                                disable-sort
                              >
                                <template v-slot:body="{ items }">
                                  <tr
                                    v-for="(item, index) in items"
                                    :key="index"
                                    :class="{
                                      'separator-row': item.isSeparator,
                                    }"
                                    class="cost-table"
                                  >
                                    <td v-if="!item.isSeparator">
                                      <div class="pa-3">
                                        {{ item["PLAN NAME"] }}
                                      </div>
                                    </td>
                                    <td v-if="!item.isSeparator">
                                      <div class="pa-3">
                                        {{ item["FS_DESCRIPTION"] }}
                                      </div>
                                    </td>
                                    <td v-if="!item.isSeparator">
                                      <div class="pa-3">
                                        {{ item["RATE_AMOUNT"] }}
                                      </div>
                                    </td>
                                    <td
                                      v-else
                                      colspan="4"
                                      class="separator-cell"
                                    ></td>
                                  </tr>
                                </template>
                              </v-data-table>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="green darken-1"
                                text
                                @click="costDialog = false"
                                >Close</v-btn
                              >
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </template>
                    </div>
                  </div>
                </div>

                <v-expansion-panels accordion style="margin-bottom: 0px">
                  <v-expansion-panel style="margin-bottom: 0px">
                    <v-expansion-panel-header
                      >Quick Look</v-expansion-panel-header
                    >
                    <v-expansion-panel-content>
                      <table class="plan-table">
                        <thead>
                          <tr v-if="plan.planLevels.length != 1">
                            <th>Plan Name</th>
                            <th>Pricing starts at</th>
                          </tr>
                          <tr v-else>
                            <th>Plan Name</th>
                            <th>Pricing</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                           v-for="(planLevel, index) in plan.planLevels"
                            :key="index"
                          >
                            <td>{{ planLevel.planName }}</td>
                            <td>{{ toCurrency(planLevel.planPrice) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </div>
          </div>
        </div>
        <div
          style="
            max-width: 400px;
            margin: 0 auto;
            text-align: center;
            padding-bottom: 20px;
          "
          class="flex-row-wrapper"
        >
          <a
            v-if="quoteBtn === 1"
            @click="openshow_enrollquotedialog('quote')"
            style="flex: 1; text-decoration: none; padding: 5px"
          >
            <div class="branded-btn2">Quote</div>
          </a>
          <a
            v-if="enrollBtn === 1"
            @click="openshow_enrollquotedialog('enroll')"
            style="flex: 1; text-decoration: none; padding: 5px"
          >
            <div class="branded-enroll-btn">Enroll</div>
          </a>
        </div>
      </div>
    </div>

    <v-dialog v-if="!invalidSite" v-model="show_enrollquotedialog" max-width="600px" persistent>
      <v-card style="height: 93vh; display: flex; flex-direction: column">
        <v-card-text style="padding: 0; flex: 1">
          <iframe
            :src="show_enrollquoteurl"
            width="100%"
            height="100%"
            style="width: 100%; height: 100%; border: none; display: block"
            frameborder="0"
            class="enrollQuoteiframe"
          ></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div v-if="!invalidSite" style="background-color: #555">
      <div
        class="width-wrapper"
        style="color: #ffffff; text-align: center; padding: 10px"
      >
        © 2025 Benefit Allocation Systems LLC
      </div>
    </div>
  </v-app>
</template>


<style scoped>
.v-dialog__content {
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch;
}
.v-card {
  max-height: 90vh;
  overflow-y: auto;
}
.enrollQuoteiframe {
  min-height: 400px;
  width: 100%;
  border: none;
  display: block;
}
@media screen and (max-width: 767px) {
  .v-card {
    max-height: 100vh;
  }
  .enrollQuoteiframe {
    min-height: 200px;
  }
}
</style>
 <script>
import axios from "axios";

 // import "@/assets/stylesheets/style32.css";

 // TEST WITH http://localhost:8080/association_homepage/index.html?site=4483FC8EC68C4C25E063320A12ACC51F

/* eslint-disable */

export default {
  data() {
    return {
      plans: [],
      headers: [
        { text: "Plan Name", value: "PLAN NAME" },
        { text: "Description", value: "FS_DESCRIPTION" },
        { text: "Rate Amount", value: "RATE_AMOUNT" },
      ],
      isloginrestrictval: null,
      security_url: "",

      quoteBtn: 1,
      enrollBtn: 1,
      show_enrollquotedialog: false,
      show_enrollquoteurl: "",
      planCosts: [],
      cat_code: "",
      site_id: "",
      guid: "",
      logoText: "",
      costDialog: false,
      detailsDialog: false,
      drawer: false,
      dialog: false,
      plansDialog: false,
      invalidSite: false,
      selectedSubmenu: {},
      association: {
        header: {
          title: "Default Title",
          subtitle: "Default Subtitle",
        },
        navbar: [],
        planOptions: [],
      },
    };
  },
  created() {
    const queryParams = new URLSearchParams(window.location.search);
    var siteParam = queryParams.get("site");

    if (!siteParam) {
      this.invalidSite = true;
      return;
    }
    this.GetProgramType(siteParam);
  },
  watch: {},

  methods: {
    async checkGeolocationapi() {
      var self = this;
      var program_type_ = this.site_id;
      const url_ = new URL(window.location.href);
      try {
        const response = await axios.post(
          `${self.methodUrl_1}/Generic_Temps_webmethods/GeoLocationService.asmx/CheckGeolocation`,
          {
            applicationName: "associationhomepage", //change the application name
            url: url_, //change url
            program_type: program_type_,
          }
        );

        const result = response.data.d;
        // console.log(result.length);

        var isloginrestrictval_result = result.isLoginRestricted;
        this.security_url = result.securityUrl;
        if (!isloginrestrictval_result) {
          this.isloginrestrictval = false;
        } else if (isloginrestrictval_result) {
          this.isloginrestrictval = true;
        }
      } catch (error) {
        console.error("Error calling checkGeolocationapi:", error);
      }
    },

    movototoppage() {
      window.scrollTo(0, 0);
    },

    addTemplateCSS() {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = `https://www.me-content.com/mec/AssociationsHomepage/css/template_style.css?v=${new Date().getTime()}`;
      document.head.appendChild(link);
    },
    handleMessage(event) {
      if (event.data.action === "closeEnrollQuoteDialog") {
        this.closeEnrollQuoteDialog();
      }
    },
    GetPlanCost(value) {
      var self = this;
      var program_type_ = this.site_id;
      this.costDialog = true;
      axios
        .post(
          self.methodUrl +
            "/BrandedHomePageWebService/WebMethod.aspx/GetPlanInfo",
          {
            program_type: program_type_,
            category_code: value,
          }
        )
        .then((r) => {
          var plans = JSON.parse(r.data.d);
         // console.log(plans);
          this.plans = JSON.parse(r.data.d);
        })
        .catch((error) => {});
    },

    openCostDialog(cat_code) {
      this.cat_code = cat_code; // Set the cat_code dynamically
      this.GetPlanCost(this.site_id); // Fetch plan costs
      this.costDialog = true; // Open the dialog
    },

    closeEnrollQuoteDialog() {
      // console.log("closeEnrollQuoteDialog button clicked");
      this.show_enrollquotedialog = false;
    },

    enroll_quote_domain() {
      const href = location.href.toLowerCase();
      if (href.indexOf("bas1.myenroll") > -1) {
        return "https://www.bas1.myenroll.com";
      } else {
        return "https://www.temp.bastest.com";
      }
    },

    openshow_enrollquotedialog(type) {
      const domain = this.enroll_quote_domain();
      const url = `${domain}/ee_signup_newhire_temps/index.html?site=${
        this.site_id
      }&type=${type === "enroll" ? 1 : 2}&v=${new Date().getTime()}`;
      this.show_enrollquoteurl = url;
      this.show_enrollquotedialog = true;
    },

    GetMenuItems() {
      var self = this;
      var program_type_ = this.site_id;
      axios
        .post(
          self.methodUrl +
            "/BrandedHomePageWebService/WebMethod.aspx/GetNavBarMenuItems",
          {
            program_type: program_type_,
          }
        )
        .then((r) => {
          this.association.navbar = JSON.parse(r.data.d);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    GetPlans() {
      var self = this;
      var program_type_ = this.site_id;
      axios
        .post(
          self.methodUrl +
            "/BrandedHomePageWebService/WebMethod.aspx/GetPlansItems",
          {
            program_type: program_type_,
          }
        )
        .then((r) => {
         
          var planOptions = JSON.parse(r.data.d);
          console.log(planOptions);
          planOptions.map((option, index) => {
           
            var sortedPlanLevels = option.planLevels.sort((a,b)=> parseFloat(a.planPrice.replace(/[$,]/g, "")) - parseFloat(b.planPrice.replace(/[$,]/g, "")));
           planOptions[index].planLevels=sortedPlanLevels;
           
          })
         // this.association.planOptions = JSON.parse(r.data.d);
         this.association.planOptions = planOptions;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /* GetLogoText() {
      var self = this;
      var program_type_ = this.site_id;
      var LOGOTEXT = null;
      axios
        .post(
          self.methodUrl +
            "/BrandedHomePageWebService/WebMethod.aspx/GetMainText",
          {
            program_type: program_type_,
            LOGOTEXT: LOGOTEXT,
          }
        )
        .then((r) => {
          var responseData = JSON.parse(r.data.d);
          this.logoText = responseData[0].LOGOTEXT; 
          console.log("Logo Text:", this.logoText);
        })
        .catch((error) => {
          console.log(error);
        });
    }, */

    GetAssociationHeader() {
      var self = this;
      var program_type_ = this.site_id;

      axios
        .post(
          self.methodUrl +
            "/BrandedHomePageWebService/WebMethod.aspx/GetMainText",
          {
            program_type: program_type_,
          }
        )
        .then((r) => {
          const headerData = JSON.parse(r.data.d);
          this.association.header = {
            title: headerData[0].TITLE,
            subtitle: headerData[0].SUBTITLE,
          };
          this.logoText = headerData[0].LOGOTEXT;
          this.quoteBtn = headerData[0].QUOTE;
          this.enrollBtn = headerData[0].ENROLL;
         // console.log("Quote" + this.quoteBtn + "Enroll" + this.enrollBtn);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    GetProgramType(guid_) {
      var self = this;
      this.guid = guid_;
      axios
        .post(
          self.methodUrl +
            "/BrandedHomePageWebService/WebMethod.aspx/GetProgramType",
          {
            guid: guid_,
          }
        )
        .then((r) => {
          if (!r.data.d) {
            this.invalidSite = true;
            return;
          }
          this.site_id = r.data.d;
          this.GetCSS();
          this.GetMenuItems();
          this.GetPlans();
          this.GetAssociationHeader();
          this.checkGeolocationapi();
          // this.GetLogoText();
         // console.log("GUID:", this.guid);
        })
        .catch((error) => {
          console.log(error);
          this.invalidSite = true;
        });
    },
    GetCSS() {
      var self = this;
      var program_type_ = this.site_id;
      axios
        .post(
          self.methodUrl + "/BrandedHomePageWebService/WebMethod.aspx/GetCSS",
          {
            program_type: program_type_,
          }
        )
        .then((r) => {
          const link = document.createElement("link");
          link.rel = "stylesheet";
          link.href = r.data.d + `?v="${new Date().getTime()}`;
          document.head.appendChild(link);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openModal(submenu) {
      this.selectedSubmenu = submenu;
      if (submenu.file_type == "PROC") {
      //  console.log("Within PROC");
        this.GetPlanCost("%"); //"%" - get ALL plans and costs
      } else if (submenu.file_type == "VUE") {
      //  console.log("Within VUE");
        this.openmenu_enrollquotedialog(submenu.file_url);
      } else {
        
        if (submenu.file_url && submenu.file_url.toLowerCase().includes('.pdf')) {
          this.plansDialog = true;
        } else {
          this.dialog = true;
          }
      }
      
    },
    openmenu_enrollquotedialog(url) {
      if (
        location.href.toLowerCase().indexOf("test") !== -1 ||
        location.hostname === "localhost"
      ) {
        url = url.replace(
          "https://www.bas1.myenroll.com",
          "https://www.temp.bastest.com"
        );
      }
      var url_ = url + "&v=${new Date().getTime()}";
      this.show_enrollquoteurl = url_;
      this.show_enrollquotedialog = true;
    },

    toCurrency(value) {
      if (typeof value !== "number") {
        return value;
      }
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(value);
    },
  },
  computed: {
    methodUrl_1() {
      const href = location.href.toLowerCase();
      if (href.indexOf("bas1.myenroll") > -1) {
        return "https://www.bas1.myenroll.com";
      } else if (href.indexOf("temp.bastest") > -1) {
        return "https://www.temp.bastest.com";
      } else if (href.indexOf("localhost") > -1) {
        return "http://localhost/web_projects";
      } else {
        return "";
      }
    },

    methodUrl() {
      return location.href.toLowerCase().indexOf("test") > -1 ||
        location.href.toLowerCase().indexOf("myenroll") > -1
        ? "/web_projects"
        : "http://localhost/web_projects";
    },

    menusWithSubmenus() {
      // Check if navbar is defined and filter menus with submenus
      if (!this.association.navbar) return [];
      return this.association.navbar.filter(
        (menu) => menu.submenus && menu.submenus.length > 0
      );
    },
    menusWithoutSubmenus() {
      // Check if navbar is defined and filter menus without submenus
      if (!this.association.navbar) return [];
      return this.association.navbar.filter(
        (menu) =>
          (!menu.submenus || menu.submenus.length === 0) && menu.file_url
      );
    },

    groupedPlans() {
      const grouped = [];
      let lastPlanName = null;

      this.plans.forEach((plan) => {
        if (plan["PLAN NAME"] !== lastPlanName) {
          if (lastPlanName !== null) {
            // Add a separator row
            grouped.push({ isSeparator: true });
          }
          lastPlanName = plan["PLAN NAME"];
        }
        grouped.push(plan);
      });
      return grouped;
    },
  },

  mounted() {
    var self = this;

    // Dynamically add the script to the body THIS IS NEW SCRIPT
    const script = document.createElement("script");
    script.id = "ze-snippet";
    script.src =
      "https://static.zdassets.com/ekr/snippet.js?key=5dc32f31-303a-4577-b349-71ba1c77ab8f";
    script.async = true; // Load the script asynchronously
    document.body.appendChild(script); // Append the script to the body

    this.addTemplateCSS();
    window.addEventListener("message", function (event) {
      if (event.data.action === "closeEnrollQuoteDialog") {
        this.closeEnrollQuoteDialog();
      }
      if (event.data.action === "movototoppage") {
        self.movototoppage();
      }
    });

    window.addEventListener("message", this.handleMessage);
  },

  beforeUnmount() {
    window.removeEventListener("message", this.handleMessage);
  },
};
</script>